<template>
    <div class="public-offer">
        <div class="blured-content" v-if="authorized || !authBefore">
            <transition name="fade" mode="out-in">
                <div key="wrapper" v-if="!loaders.all">
                    <UsualAlert
                        class="mb-14"
                        v-if="!isProductOnSale && cabinetName"
                        type="helping-red"
                        v-html="t('payments.payments_are_temporarily_suspended').replace('%name%', cabinetName)"
                    >
                    </UsualAlert>
                    <public-offer-heading class="mb-10" :viewed-product="viewedProduct" :product-title="productTitle" />
                    <div class="public-offer__layout">
                        <div class="public-offer__content">
                            <!--                            <public-offer-order-mobile
                                v-if="order && $vssWidth <= 960"
                                ref="OrderMobile"
                                :loading="loaders.order"
                                :order="order"
                                :class="{ disabled: !isProductOnSale }"
                                :allowCoupons="allowCoupons"
                                :allow-points="allowPoints"
                                :isProductOnSale="isProductOnSale"
                                :showPaymentLinks="showPaymentLinks"
                                :paymentType="paymentType"
                                :paymentUpdateLoading="paymentUpdateLoading"
                                :paymentParts="paymentParts"
                                :orderUpdateError="orderUpdateError"
                                :selectedMerchant="selectedMerchant"
                                @update="updateOrder($event)"
                                @selectedMerchant:change="selectedMerchant = $event"
                                @change:paymentType="setPaymentMethod"
                                @show:links="showPaymentLinks = $event"
                                :payment="payment"
                                :auth="userAuth"
                                @paymentAuth="paymentAuth"
                            />-->
                            <div class="public-order__content" v-if="defOrder">
                                {{ productAcessTitle }}: {{ allProducts.join(", ") }}
                            </div>
                            <public-offer-upsell
                                v-if="upsell.length"
                                :class="{ disabled: !isProductOnSale }"
                                :upsell="upsell"
                                :showFreeTitle="showFreeTitle"
                                :key="`upsell-${upsellUpdate}`"
                                @update="fetchOffers(true, 'upsell')"
                                @updateCrossSells="fetchOffers(true, 'crossSell', true)"
                            />
                            <public-offer-empty
                                v-if="(offer && !offer.is_active) || orderWithoutOffers || (product && !upsell.length)"
                            />
                            <public-offer-cross-sell
                                class="mt-20"
                                :class="{ disabled: !isProductOnSale }"
                                v-if="crossSell.length"
                                :cross-sell="crossSell"
                                :showFreeTitle="showFreeTitle"
                                :key="`crossSell-${crossSellUpdate}`"
                                @update="fetchOffers(true, 'crossSell')"
                            />
                        </div>
                        <div class="order-wrapper">
                            <public-offer-order
                                v-if="order"
                                ref="OrderDesktop"
                                :loading="loaders.order"
                                :class="{ disabled: !isProductOnSale }"
                                :order="order"
                                :payment="payment"
                                :allowCoupons="allowCoupons"
                                :allow-points="allowPoints"
                                :isProductOnSale="isProductOnSale"
                                :showPaymentLinks="showPaymentLinks"
                                :paymentType="paymentType"
                                :paymentUpdateLoading="paymentUpdateLoading"
                                :paymentParts="paymentParts"
                                :orderUpdateError="orderUpdateError"
                                :selectedMerchant="selectedMerchant"
                                :auth="userAuth"
                                @set:orderId="setOrderId($event)"
                                @update="updateOrder($event)"
                                @paymentAuth="paymentAuth"
                                @selectedMerchant:change="selectedMerchant = $event"
                                @change:paymentType="setPaymentMethod"
                                @show:links="showPaymentLinks = $event"
                            />
                        </div>
                    </div>
                </div>
                <SpinLoader key="loader" v-else />
            </transition>
        </div>

        <div v-else>
            <DefaultAuthModal :login-action="reload" :visible="true" />
        </div>
    </div>
</template>

<script>
import PublicOfferHeading from "./components/PublicOfferHeading"
import PublicOfferUpsell from "./components/PublicOfferUpsell"
import PublicOfferCrossSell from "./components/PublicOfferCrossSell"
import PublicOfferOrder from "./components/PublicOfferOrder"
import PublicOfferEmpty from "./components/PublicOfferEmpty"
import VueScreenSize from "vue-screen-size"
import formatDate from "@mixins/formatDate"
import BugIcon from "@icons/BugIcon"
import DefaultAuthModal from "../../../PublicModal/view/DefaultAuthModal"
import SpinLoader from "@components/Loaders/SpinLoader"
import axios from "@libs/axios"
import { EventBus } from "~events"
import { DEFAULT_AUTH_KEY } from "@public-modal/shared/keys/default-auth-key"
import UsualAlert from "@components/Alerts/UsualAlert"

export default {
    props: {
        offer: {
            type: Object,
            default: null
        },
        product: {
            type: Object,
            default: null
        },
        defPayment: {
            type: Object,
            default: null
        },
        isProductOnSale: {
            type: Boolean,
            default: true
        },
        message: {
            type: String,
            default: ""
        },
        auth: {
            type: Boolean,
            default: false
        },
        authBefore: {
            type: Boolean,
            default: false
        },
        defOrder: {
            type: Object,
            default: null
        }
    },
    mixins: [VueScreenSize.VueScreenSizeMixin, formatDate],
    components: {
        SpinLoader,
        DefaultAuthModal,
        UsualAlert,
        PublicOfferOrder,
        PublicOfferCrossSell,
        PublicOfferUpsell,
        PublicOfferHeading,
        PublicOfferEmpty
    },
    name: "PublicOfferView",
    data() {
        return {
            upsell: [],
            crossSell: [],
            order: null,
            payment: null,
            authorized: this.auth,
            loaders: {
                all: true,
                order: false
            },
            allowCoupons: false,
            allowPoints: false,
            showPaymentLinks: false,
            paymentType: "full",
            paymentUpdateLoading: false,
            paymentParts: [],
            orderUpdateError: null,
            currentUpsells: [],
            currentCrossSells: [],
            upsellsDiscountsScheduleList: [],
            nowTimestamp: null,
            upsellsDiscountsScheduleInterval: 0,
            upsellUpdate: 0,
            crossSellUpdate: 0,
            onlyBaseOffer: false,
            cabinetName: null,
            paymentTypes: {
                is_pay_all_sum_now: "full",
                is_pay_by_equal_parts: "equal_parts",
                is_pay_by_specified_schedule: "specified_schedule",
                is_bank_credit_allowed: "bank_parts"
            },
            selectedMerchant: null,
            userAuth: false,
            paymentOptionsCount: 0,
            partPaymentSingleMethodName: null,
            orderWithoutOffers: false
        }
    },
    computed: {
        relatedType() {
            if (this.offer) {
                return "offer"
            } else {
                return "product"
            }
        },
        selectedUpsellIds() {
            return [...this.upsell].reduce((accumulator, current) => {
                if ("is_selected" in current && current.is_selected) {
                    accumulator.push(current.id)
                }
                if ("is_checked" in current && current.is_checked) {
                    accumulator.push(current.id)
                }
                return accumulator
            }, [])
        },
        selectedCrossSellsIds() {
            return [...this.crossSell].reduce((accumulator, current) => {
                if ("is_checked" in current && current.is_checked) {
                    accumulator.push(current.id)
                }
                return accumulator
            }, [])
        },
        selectedOffers() {
            return [...this.upsell, ...this.crossSell].reduce((accumulator, current) => {
                if (
                    ("is_selected" in current && current.is_selected) ||
                    ("is_checked" in current && current.is_checked)
                ) {
                    accumulator.push(current)
                }
                return accumulator
            }, [])
        },
        paidUpsellsIds() {
            return [...this.upsell].reduce((accumulator, current) => {
                if (current.is_free) return accumulator
                accumulator.push({ id: current.id })
                return accumulator
            }, [])
        },
        productTitle() {
            if (this.viewedProduct.length && this.offer) {
                return this.t("payments.public-offer.products")
            }
            if (this.viewedProduct.length <= 1 && this.product && this.product.productable_type === "course") {
                return this.t("payments.public-offer.course")
            }
            if (this.viewedProduct.length > 2 && this.product && this.product.productable_type === "course") {
                return this.t("payments.public-offer.courses")
            }
            if (this.viewedProduct.length <= 1 && this.product && this.product.productable_type === "webinar") {
                return this.t("payments.public-offer.webinar")
            }
            if (this.viewedProduct.length > 2 && this.product && this.product.productable_type === "webinar") {
                return this.t("payments.public-offer.webinars")
            }
            if (this.defOrder) {
                return `${this.t("expert.order")} #${this.order.id}`
            }
            return ""
        },
        viewedProduct() {
            const products = new Map()
            if (this.offer) {
                const upsell = this.upsell.find(upsell => upsell.is_selected)

                if (upsell) {
                    upsell.products.forEach(product => {
                        const { name, link } = product
                        products.set(product.id, {
                            name,
                            link
                        })
                    })
                }
            } else if (this.product) {
                products.set(this.product.id, {
                    name: this.product.name || this.product.productable.title || "",
                    link: this.product.link || this.product.productable.link || ""
                })
            }

            return Array.from(products.values())
        },
        allProducts() {
            let products = []

            this.order.offers.forEach(offer => {
                products = offer.products.map(i => i.name)
            })

            return products
        },
        productAcessTitle() {
            if (this.allProducts.length > 1) {
                return this.t("expert.products_acess")
            }
            return this.t("expert.product_acess")
        },
        showFreeTitle() {
            return this.upsell.some(offer => !offer.is_free) || this.crossSell.some(offer => !offer.is_free)
        }
    },
    watch: {
        upsell: {
            deep: true,
            async handler() {
                if (!this.order) {
                    await this.createOrder()
                } else {
                    await this.updateOrder()

                    // Update partial payment if selected
                    if (
                        this.paymentType !== this.paymentTypes.is_pay_all_sum_now &&
                        this.paymentType !== this.paymentTypes.is_bank_credit_allowed
                    ) {
                        await this.updatePaymentOptions()
                    }
                }
            }
        },
        crossSell: {
            deep: true,
            async handler() {
                if (!this.order) {
                    await this.createOrder()
                } else {
                    await this.updateOrder()

                    // Update partial payment if selected
                    if (
                        this.paymentType !== this.paymentTypes.is_pay_all_sum_now &&
                        this.paymentType !== this.paymentTypes.is_bank_credit_allowed
                    ) {
                        await this.updatePaymentOptions()
                    }
                }
            }
        }
    },
    provide() {
        return {
            getPaymentTypes: () => this.paymentTypes
        }
    },
    async created() {
        this.payment = this.defPayment
        this.userAuth = this.auth

        if (this.authorized || !this.authBefore) {
            // Get data for current order
            await this.getCurrentOrderData()
            // Get upsells, cross-sells
            await this.fetchOffers()
            // Get upsells discounts schedule
            await this.getUpsellsDiscountsScheduleData()
        }

        if (this.message) {
            this.$notify({
                position: "top-right",
                color: "danger",
                time: 5000,
                title: this.t("expert.something_went_wrong"),
                text: this.message,
                icon: BugIcon
            })
        }
    },
    methods: {
        modifyFields(fields) {
            return fields.map(field => {
                return {
                    ...field,
                    text: field.title,
                    value: ""
                }
            })
        },
        reload() {
            location.reload()
        },
        async loginAction({ token }) {
            this.reload()
            return
            // eslint-disable-next-line no-unreachable
            EventBus.$emit(`${DEFAULT_AUTH_KEY}_HIDE`)
            setTimeout(async () => {
                if (token) {
                    this.$set(this, "authorized", true)
                    this.replaceHeader().then()

                    axios.defaults.headers.common = {
                        Authorization: `Bearer ${token}`,
                        "X-Language": window.app_current_locale
                    }
                    // Get data for current order
                    await this.getCurrentOrderData()
                    // Get upsells, cross-sells
                    await this.fetchOffers()

                    if (this.upsell.length === 1 && this.upsell[0].is_free) {
                        location.reload()
                    }
                    // Get upsells discounts schedule
                    await this.getUpsellsDiscountsScheduleData()
                }
            }, 0)
        },
        // Get page data
        async getCurrentOrderData() {
            if (this.defOrder) {
                try {
                    const params = {}

                    if (this.defPayment) {
                        params.payment_id = this.defPayment.id
                    }

                    const res = await axios.get(`public/orders/${this.defOrder.id}`, { params })
                    this.order = res.data.data
                    this.loaders.all = false
                    // Set the last payment method
                    this.setPaymentMethod()
                } catch (e) {
                    console.log("getCurrentOffersIds:", e)
                }
            } else {
                const itemId = this.product ? this.product.id : this.offer.id
                const orderType = this.product ? "product" : "offers"
                try {
                    const res = await axios.get(`public/${orderType}/${itemId}/order-list`)
                    this.currentUpsells = res.data.data.upSells || []
                    this.currentCrossSells = res.data.data.crossSells || []
                    this.onlyBaseOffer = res.data.data.onlyBaseOffer
                } catch (e) {
                    console.log("getCurrentOffersIds:", e)
                }
            }
        },
        async fetchOffers(shadow = false, offerType = null, updateOnly = false) {
            if (!shadow) this.loaders.all = true
            // Get data for offer from specified url
            if (this.offer) {
                if (!shadow || (shadow && offerType === "upsell")) {
                    try {
                        const response = await axios.get(`offers/${this.offer.id}/upsells`)
                        const data = response.data.data

                        if (shadow) {
                            this.offersShadowUpdate(data, "upsell")
                        } else {
                            data.forEach(offer => this.upsell.push({ ...offer, is_selected: false }))
                            if (this.upsell[0]) this.upsell[0].is_selected = true
                        }
                    } catch (e) {
                        console.log(e)
                    }
                }

                if (!this.onlyBaseOffer && (!shadow || (shadow && offerType === "crossSell"))) {
                    try {
                        const response = await axios.get(`offer/cross-sell?offers[]=${this.offer.id}`)
                        const data = response.data.data

                        shadow
                            ? this.offersShadowUpdate(data, "crossSell")
                            : data.forEach(offer => this.crossSell.push({ ...offer, is_checked: false }))

                        await this.checkLogEvents()
                    } catch (e) {
                        console.log(e)
                    }
                }
            }
            // Get data for product offers
            if (this.product) {
                if (!shadow || (shadow && offerType === "upsell")) {
                    try {
                        const response = await axios.get(`products/${this.product.id}/offers?is_public=1`)
                        const data = response.data.data

                        if (shadow) {
                            this.offersShadowUpdate(data, "upsell")
                        } else if (!this.currentUpsells.length) {
                            data.forEach(offer => this.upsell.push({ ...offer, is_selected: false }))
                            this.upsell[0].is_selected = true
                        } else {
                            data.forEach(offer =>
                                this.upsell.push({
                                    ...offer,
                                    is_selected: this.currentUpsells.indexOf(offer.id) !== -1
                                })
                            )

                            if (!this.upsell.find(upsell => upsell.is_selected)) {
                                this.upsell[0].is_selected = true
                            }
                        }
                    } catch (e) {
                        console.log(e)
                    }
                }
                if (!this.onlyBaseOffer && (!shadow || (shadow && offerType === "crossSell"))) {
                    try {
                        let query = []
                        for (const offer of this.upsell) {
                            // Get cross-sells only from selected upsells
                            if (offer.is_selected) query.push(`offers[]=${offer.id}`)
                            // query.push(`offers[]=${offer.id}`)
                        }
                        query.push(`is_public=1`)
                        const response = await axios.get(`offer/cross-sell?${query.join("&")}`)
                        const data = response.data.data

                        if (shadow) {
                            updateOnly
                                ? (this.crossSell = data.map(offer => {
                                      offer.is_checked = false
                                      return offer
                                  }))
                                : this.offersShadowUpdate(data, "crossSell")
                        } else {
                            data.forEach(offer => this.crossSell.push({ ...offer, is_checked: false }))
                        }
                    } catch (e) {
                        console.log(e)
                    }
                }
            }
            this.loaders.all = false
        },
        // Update offers
        offersShadowUpdate(data, listType) {
            const oldOffers = [...this[`${listType}`]]
            const newOffers = [...data]
            const checkboxKey = listType === "upsell" ? "is_selected" : "is_checked"

            for (const newOffer of newOffers) {
                for (const oldOffer of oldOffers) {
                    if (newOffer.id === oldOffer.id) newOffer[checkboxKey] = oldOffer[checkboxKey]
                }
            }

            this.$set(this, listType, newOffers)
            this[`${listType}Update`]++
        },
        // Create/update order
        async createOrder() {
            if (!this.selectedOffers.length) {
                return
            }
            try {
                const requestData = {
                    related_id: this.offer ? this.offer.id : this.product.id,
                    related_type: this.relatedType,
                    offers: this.selectedUpsellIds,
                    cross_sell_ids: this.selectedCrossSellsIds,
                    is_using_points: false
                }
                const response = await axios.post("public/orders", requestData)
                const order = {
                    ...response.data.data,
                    selectedOffers: response.data.data.offers
                }
                if (response.data.fields.length) {
                    order.fields = this.modifyFields(response.data.fields)
                    order.save_fields_endpoint = response.data.save_fields_endpoint
                }

                if (response.data.policy) {
                    order.policy = response.data.policy
                }

                this.order = order

                // Check offer in order
                this.checkOffersInOrder()

                // Select existed crossSells in order after page reload
                for (let i = 0; i < this.crossSell.length; i++) {
                    if (response.data.data.offers.find(offer => offer.id === this.crossSell[i].id)) {
                        this.crossSell[i].is_checked = true
                    }
                }

                // Check selected offers for coupons allowance
                this.checkCouponAllowance()

                // Check selected offers for points allowance
                this.checkPointsAllowance()

                // Get payment options quantity
                if (this.order.offer) this.countPaymentOptions()

                // Set the last payment method
                this.setPaymentMethod()
            } catch (e) {
                console.log(e)
            }
        },
        paymentAuth(token) {
            if (token) {
                //location.reload()\
                this.replaceHeader().then()
                localStorage.setItem("token", token)
                axios.defaults.headers.common = {
                    Authorization: `Bearer ${token}`,
                    "X-Language": window.app_current_locale
                }
                this.userAuth = true
                this.payAfterLogin("payment", "links")
            }
        },
        setOrderId(id) {
            console.log(id)
            this.order = {
                ...this.order,
                id
            }
        },
        async updateOrder(token) {
            if (token) {
                //location.reload()\
                this.replaceHeader().then()
                localStorage.setItem("token", token)
                axios.defaults.headers.common = {
                    Authorization: `Bearer ${token}`,
                    "X-Language": window.app_current_locale
                }
                this.userAuth = true
            }

            this.loaders.order = true

            try {
                const requestData = {
                    is_using_points: this.order.is_using_points,
                    offers: this.selectedUpsellIds,
                    cross_sell_ids: this.selectedCrossSellsIds
                }
                const response = await axios.put(`public/orders/${this.order.id}`, requestData)
                const order = {
                    ...response.data.data,
                    selectedOffers: response.data.data.offers
                }
                if (response.data.fields.length) {
                    order.fields = this.modifyFields(response.data.fields)
                    order.save_fields_endpoint = response.data.save_fields_endpoint
                }

                if (response.data.policy) {
                    order.policy = response.data.policy
                }

                this.order = order

                // Check offer in order
                this.checkOffersInOrder()

                // Check selected offers for coupons allowance
                this.checkCouponAllowance()

                // Check selected offers for points allowance
                this.checkPointsAllowance()

                // Get payment options quantity
                if (this.order.offer) this.countPaymentOptions()

                // Set the last payment method
                this.setPaymentMethod()

                if (token) this.payAfterLogin()
            } catch (e) {
                if (e.response.data.message) this.orderUpdateError = e.response.data.message
            } finally {
                this.loaders.order = false
            }
        },
        checkOffersInOrder() {
            this.orderWithoutOffers = !this.order.offers.length
        },
        // Work with discounts
        async getUpsellsDiscountsScheduleData() {
            if (!this.paidUpsellsIds.length) {
                return
            }
            try {
                const res = await axios.post("/offers/schedule-change-price", { offers: this.paidUpsellsIds })
                const data = res.data.data

                data.forEach(discount => {
                    this.upsellsDiscountsScheduleList = [
                        ...this.upsellsDiscountsScheduleList,
                        this.toTimestamp(discount.start_at_utc)
                    ]
                })

                this.createUpsellsDiscountsScheduleInterval()
            } catch (e) {
                console.log("checkDiscounts error:", e)
            }
        },
        async replaceHeader() {
            let documentUrl = document.URL.indexOf("?") > -1 ? document.URL + "&fetch=1" : document.URL + "?fetch=1"
            const html = await (await fetch(documentUrl)).text()
            const doc = new DOMParser().parseFromString(html, "text/html")
            document.querySelector(".content-header-part").outerHTML =
                doc.body.querySelector(".content-header-part").outerHTML

            document.querySelectorAll("#logoutAction").forEach(action => {
                action.addEventListener("click", event => {
                    event.preventDefault()
                    const headers = new Headers()
                    let token = localStorage.getItem("token")

                    if (!token || token !== window.token) token = window.token

                    headers.append("Authorization", `Bearer ${token}`)

                    fetch("/api/v1/auth/logout", {
                        method: "get",
                        headers
                    })
                        .then(() => {
                            location.reload()
                        })
                        .catch(err => console.log("Logout error:", err))
                })
            })
        },
        createUpsellsDiscountsScheduleInterval() {
            this.nowTimestamp = this.toTimestamp(new Date())

            this.upsellsDiscountsScheduleInterval = setInterval(() => {
                this.nowTimestamp += 1

                if (this.upsellsDiscountsScheduleList.indexOf(this.nowTimestamp) !== -1) {
                    this.fetchOffers(true, "upsell")
                }
            }, 1000)
        },
        // Update payment options for partial/one-time payment
        async setPaymentMethod(type) {
            this.paymentType = type || this.order.type_partial_payment
            await this.updatePaymentOptions()
        },
        async updatePaymentOptions() {
            if (this.paymentUpdateLoading) return
            this.paymentUpdateLoading = true

            const data = { payment_type: this.paymentType }

            if (!this.paymentType) {
                this.paymentUpdateLoading = false
                return
            }

            try {
                const res = await axios.put(`public/orders/${this.order.id}/schedule`, data)
                this.paymentParts = res.data.data
            } catch (e) {
                console.log("payment update error:", e)
            } finally {
                this.paymentUpdateLoading = false
            }
        },
        // Check coupons allowance
        checkCouponAllowance() {
            this.allowCoupons = false

            for (let i = 0; i < this.order.selectedOffers.length; i++) {
                if (this.order.selectedOffers[i].is_coupon_allowed) {
                    this.allowCoupons = true
                    break
                }
            }
        },
        // Check coupons allowance
        checkPointsAllowance() {
            this.allowPoints = false

            for (let i = 0; i < this.order.selectedOffers.length; i++) {
                if (this.order.selectedOffers[i].is_points_enabled) {
                    this.allowPoints = true
                    break
                }
            }
        },

        // Other
        goBack() {
            window.history.go(-1)
        },
        async checkLogEvents() {
            try {
                await axios.post(`/offers/${this.offer.unique_offer_code}/events/opened`)
            } catch (e) {
                console.log()
            }
        },
        async payAfterLogin(type = "order", linksKey = "payment_links") {
            //this.$refs.OrderDesktop.requiredFieldsNotFilled()
            if (this.order?.fields?.length) {
                return
            }

            // Condition for order with partial payments
            if (type === "order" && this.order.is_partial_payment_allowed) {
                // Show single part payments method as selected
                if (this.paymentOptionsCount === 1) {
                    await this.setPaymentMethod(this.partPaymentSingleMethodName)
                    await this.payAfterLoginConditions(type, linksKey)
                }
                this.showPaymentLinks = this[type][linksKey]?.length > 1
            } else {
                await this.payAfterLoginConditions(type, linksKey)
            }
        },
        async payAfterLoginConditions() {
            await this.$refs.OrderDesktop.handlePaymentLinks()
        },
        countPaymentOptions() {
            this.paymentOptionsCount = 0
            for (const key in this.paymentTypes) {
                if (this.order.offer[key]) {
                    this.paymentOptionsCount++
                    this.partPaymentSingleMethodName = this.paymentTypes[key]
                }
            }
        }
    },
    mounted() {
        this.cabinetName = window.active_cabinet_slug.capitalize()
    }
}
</script>

<style scoped lang="sass">
.public-offer
    display: block
    margin-bottom: 159px

.order-wrapper
    height: fit-content
    transition: .3s
    box-shadow: 0 4px 10px rgba(128, 158, 191, 0.15)
    margin-left: 20px
    transition-delay: .3s
    border-radius: 10px
    background: #FFFFFF
    max-width: 450px
    width: 100%
    @media (max-width: 960px)
        margin-left: 0
        max-width: none
        margin-top: 20px

.public-order
    &__content
        box-shadow: 0 4px 10px rgba(128, 158, 191, 0.15)
        border-radius: 10px
        background: #FFFFFF
        padding: 20px

.public-offer
    padding: 0 38px
    background: #FFF
    position: relative

    .spin-loader
        position: absolute
        top: 50%
        left: 50%
        transform: translate(-50%, -50%)

    &__layout
        display: flex
        @media (max-width: 960px)
            flex-direction: column
    &__content
        flex: 1
    @media (max-width: 960px)
        padding: 0 3%
</style>
